/**
 * Wrapper over <BullhornMetadata /> component - to fetch latest metadata on a Match record's User
 */
import { useSuspenseQuery } from "@apollo/client";
import { GET_MATCH_METADATA } from "api/graphql/match";
import BullhornMetadata from "components/BullhornMetadata";

function MatchMetadataContent({ applicationId, jobOpportunityId }) {
  const { error, data } = useSuspenseQuery(GET_MATCH_METADATA, {
    variables: {
      applicationId,
      jobOpportunityId,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    return (
      <p>
        An error occurred fetching meta data for the Match. Refresh the page and
        if the error persists, contact Torc Support
      </p>
    );
  }

  return <BullhornMetadata type="table" metadata={data.metadata} />;
}

export default function MatchMetaData({ applicationId, jobOpportunityId }) {
  const hasMatchData = !!(applicationId && jobOpportunityId);

  if (!hasMatchData) {
    return (
      <section className="max-h-96 h-96 overflow-y-auto flex items-center justify-center">
        <p className="text-gray-500 text-center">
          No match data available for this user
        </p>
      </section>
    );
  }

  return (
    <MatchMetadataContent
      applicationId={applicationId}
      jobOpportunityId={jobOpportunityId}
    />
  );
}
